import React, { useState } from 'react';
import './DataTable1.css';
import SearchIcon from '@mui/icons-material/Search';

const DataTable1 = ({ data, columns }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const filteredData = data.filter((row) =>
    columns.some((col) =>
      row[col.key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="data-table-container">
      <div className="actions-area">
        <div className="search-area">
          <div className="search-input-area">
            <input
              type="text"
              className="custom-search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <SearchIcon className="custom-search-icon" />
          </div>
        </div>
      </div>

      <table className="custom-data-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} className="table-header">{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentData.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="no-data-message">
                No data available.
              </td>
            </tr>
          ) : (
            currentData.map((row, index) => (
              <tr key={index}>
                {columns.map((col) => (
                  <td key={col.key} className="table-cell">{row[col.key]}</td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="pagination-area">
        <button onClick={handlePrevPage} disabled={currentPage === 1} className="pagination-button">
          Previous
        </button>
        <span className="pagination-info">
          Page {currentPage} of {totalPages}
        </span>
        <button onClick={handleNextPage} disabled={currentPage === totalPages} className="pagination-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default DataTable1;
